export function DashboardHeader() {
  const getGreeting = () => {
    const hour = new Date().getHours();

    if (hour >= 5 && hour < 12) {
      return 'Good morning';
    } else if (hour >= 12 && hour < 18) {
      return 'Good afternoon';
    } else {
      return 'Good evening';
    }
  };

  return (
    <div className="bitte-flex bitte-justify-between bitte-items-start bitte-w-full">
      <div>
        <h1 className="bitte-text-2xl bitte-text-[#FAFAFA]">{getGreeting()}</h1>
        <p className="bitte-text-[#969696]">
          What do you want to achieve today?
        </p>
      </div>
      {/*       <div className="bitte-flex bitte-items-center bitte-gap-3">
        <div className="bitte-flex bitte-items-center bitte-gap-2 bitte-bg-[#232327] bitte-rounded-full bitte-px-3 bitte-py-1">
          <div className="bitte-w-6 bitte-h-6 bitte-rounded-full bitte-bg-emerald-500 bitte-flex bitte-items-center bitte-justify-center">
            <span className="bitte-text-xs bitte-font-bold">R</span>
          </div>
          <span className="bitte-text-sm">RHEA</span>
        </div>
        <div className="bitte-w-8 bitte-h-8 bitte-rounded-full bitte-bg-[#232327] bitte-flex bitte-items-center bitte-justify-center">
          <User className="bitte-w-4 bitte-h-4" />
        </div>
      </div> */}
    </div>
  );
}
